import cors from 'cors';
import express from 'express';
import bodyParser from 'body-parser';
import compression from 'compression';
import { orchestrateGeneralRoutes } from './general';
import { router as cliJsCodeRouter } from './cliJsCode';
import { IS_ON_PREM, DISABLE_AGENT_ORIGIN_CHECK } from '../../commons/config';
import type { Express } from 'express';

export function orchestrateRoutes(beforeMiddleware: (app: Express) => void) {
    const app = express();
    app.disable('x-powered-by');
    beforeMiddleware(app);

    app.use(bodyParser.urlencoded({ extended: false, limit: '50mb' }));
    app.use(compression());
    app.use(bodyParser.json({ limit: '50mb' }));

    // set cors options
    const whitelist = [
        'chrome-extension://pebeiooilphfmbohdbhbomomkkoghoia',
    ];
    const corsOptions = {
        methods: ['GET', 'PUT', 'POST', 'DELETE', 'OPTIONS'],
        allowedHeaders: ['Content-Type', 'Authorization'],
        credentials: true,
        maxAge: 86_400,
        origin: (IS_ON_PREM || DISABLE_AGENT_ORIGIN_CHECK) ? '*' : whitelist,
    };
    app.use('*', cors(corsOptions));

    // Routes
    orchestrateGeneralRoutes(app);

    app.use('/cliJs', cliJsCodeRouter);

    // catch 404
    app.use((req, res) => {
        res.status(404).send('Endpoint Not Found');
    });

    return app;
}
